import { Base } from '@models/base.model';
import { User } from '@models/user.model';
import { deserialize, object, serializable } from 'serializr';

enum MetadataSyncResult {
  NOT_STARTED = 'NOT_STARTED',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
}

enum CustomObjectDownloadStatus {
  NOT_STARTED = 'NOT_STARTED',
  SUCCESS = 'SUCCESS',
}

export enum MetadataSyncType {
  INITIAL_SYNC = 'INITIAL_SYNC',
  UPDATE_SYNC = 'UPDATE_SYNC',
}

class SalesforceMetadataSyncResult extends Base {
  @serializable
  public metadataSyncResult: MetadataSyncResult;

  @serializable
  public salesforceConnectionId: number;

  @serializable
  public lastSyncedAt: Date;

  @serializable
  public metadataSyncType: MetadataSyncType;

  @serializable
  public customObjectDownloadStatus: CustomObjectDownloadStatus;

  @serializable(object(User))
  public createdBy: User;

  deserialize(input: any): this {
    return Object.assign(
      this,
      deserialize(SalesforceMetadataSyncResult, input),
    );
  }
}

export {
  MetadataSyncResult,
  CustomObjectDownloadStatus,
  SalesforceMetadataSyncResult,
};
